import dynamic from 'next/dynamic'

import { useCustomDesign } from '@/components/styles/useCustomDesign'
import { Page } from '@/core/architecture'

import { ArtistTopTemplate } from './template'
import { useViewModel } from './viewModel'

const artistTopCustomDesignMap: Record<string, any> = {
  'ArtistTop_tmpl0001_v1.0': dynamic(
    () => import('@/components/customTemplates/ArtistTop/tmpl0001_v1.0')
  ),
  'ArtistTop_tmpl_abarerukun_v1.0': dynamic(
    () => import('@/components/customTemplates/ArtistTop/tmpl_abarerukun_v1.0')
  ),
  'ArtistTop_tmpl_etoneigefc_v1.0': dynamic(
    () => import('@/components/customTemplates/ArtistTop/tmpl_etoneigefc_v1.0')
  ),
}

export const ArtistTop: Page = () => {
  const { state, actions } = useViewModel()
  const { customDesign } = useCustomDesign({
    type: 'ArtistTop',
    artistId: state.artistId,
  })

  if (!customDesign) return null

  const CustomTemplate = customDesign?.templateId
    ? artistTopCustomDesignMap[customDesign?.templateId] ?? ArtistTopTemplate
    : ArtistTopTemplate

  return (
    <CustomTemplate
      state={state}
      {...actions}
      customDesign={customDesign?.templateId ? customDesign : undefined}
    />
  )
}
